import {GlobalPosterEditorJqueryElement} from '@Components/poster-editor/poster-editor.types';

export const EDITOR_LEFT_MARGIN = 120;
export const EDITOR_RIGHT_MARGIN = 342;
export const EDITOR_RIGHT_MARGIN_SMALL = 50;
export const EDITOR_BOTTOM_BAR_BOTTOM_OFFSET = 12;
export const EDITOR_DEFAULT_SCROLL_GAP = 20;

export const EDITOR_BOTTOM_PADDING_WHEN_SCROLL_AVAILABLE = 72;

export function handleScrollingOnWhiteboard(deltaX: number, deltaY: number): void {
  const whiteboardContainer = window.posterEditor?.elements[GlobalPosterEditorJqueryElement.WHITEBOARD_CONTAINER]?.get(0);
  if (!whiteboardContainer) return;

  const horizontalScrollValue = whiteboardContainer.scrollLeft + deltaX;
  const verticalScrollValue = whiteboardContainer.scrollTop + deltaY;
  whiteboardContainer.scroll({
    left: horizontalScrollValue,
    top: verticalScrollValue,
    behavior: 'instant',
  });

  window.posterEditor?.whiteboard?.refreshAllVisibleCanvases();
}

export function adjustScrollForZoom(e: WheelEvent, prevScale: number, newScale: number): void {
  if (prevScale === newScale) return;
  const whiteboardContainer = document.getElementById('poster-whiteboard-container');
  if (!whiteboardContainer) return;

  const scale = window.posterEditor?.whiteboard?.scaling.scale;
  if (!scale) return;
  const isPosterVideo = window.posterEditor?.whiteboard?.isVideo();
  const bottomBarHeight = window.PMW.redux.store.getState().posterEditorWebBottomBar.bottomBarHeight;

  const rect = whiteboardContainer.getBoundingClientRect();
  const isSidebarSmall = window.PMW.redux.store.getState().posterEditor.isSidebarSmall;
  const rightMargin = isSidebarSmall ? EDITOR_RIGHT_MARGIN_SMALL : EDITOR_RIGHT_MARGIN;

  const mouseX = e.clientX - rect.left - EDITOR_LEFT_MARGIN;
  const mouseY = e.clientY - rect.top;

  const scrollLeft = whiteboardContainer.scrollLeft;
  const scrollTop = whiteboardContainer.scrollTop;

  const contentWidth = rect.width - EDITOR_LEFT_MARGIN - rightMargin;

  const isVerticallyScrollable = whiteboardContainer.scrollHeight > whiteboardContainer.clientHeight;
  let bottomPadding = EDITOR_DEFAULT_SCROLL_GAP;

  if (isVerticallyScrollable) {
    bottomPadding = EDITOR_BOTTOM_PADDING_WHEN_SCROLL_AVAILABLE;
  }

  if (isPosterVideo && bottomBarHeight) {
    bottomPadding = bottomBarHeight + EDITOR_BOTTOM_BAR_BOTTOM_OFFSET + EDITOR_DEFAULT_SCROLL_GAP;
  }

  const contentHeight = rect.height - bottomPadding;

  const isMouseInRightMargin = mouseX >= contentWidth;
  const isMouseInBottomMargin = e.clientY - rect.top >= contentHeight;

  let newScrollLeft;
  if (isMouseInRightMargin) {
    const proposedScrollLeft = (scrollLeft + mouseX) * (newScale / prevScale) - mouseX;
    newScrollLeft = Math.max(scrollLeft, proposedScrollLeft);
  } else {
    newScrollLeft = (scrollLeft + mouseX) * (newScale / prevScale) - mouseX;
  }

  let newScrollTop;
  if (isMouseInBottomMargin) {
    const proposedScrollTop = (scrollTop + mouseY) * (newScale / prevScale) - mouseY;
    newScrollTop = Math.max(scrollTop, proposedScrollTop);
  } else {
    newScrollTop = (scrollTop + mouseY) * (newScale / prevScale) - mouseY;
  }

  whiteboardContainer.scroll({
    left: newScrollLeft,
    top: newScrollTop,
    behavior: 'instant',
  });
}

export function isMouseWheelEvent(e: WheelEvent): boolean {
  const absDelta = Math.abs(e.deltaY);
  return absDelta >= 10;
}
